<template>
	<div class="signContainer">
			
		<div class="btns">
		
				<img class="icon1" src="../assets/img/safe.png" alt="" />
				<div class="tipDetail2">电子签名已做加密处理，请放心使用！</div>
				<div @click="clearHandler" class="mybutton1">重签</div>
		
			<div @click="sureHandler" class=" mybutton2">确认</div>


		</div>
		<vue-esign ref="VueEsignRef" class="vue-esign" :width="width" :height="height" :lineWidth="lineWidth"
			:lineColor="lineColor" :bgColor="bgColor" :isClearBgColor="false" :isCrop="isCrop"  :format="format"
			:quality="quality" />
<!-- 		<div :style="{ '--width': height + 'px' }" class="tipText">
			请<span v-if="signName">{{ ` ${signName} ` }}</span>在此区域内签名
		</div> -->
		<div class="tips">

			<div class="tipDetail"> 请将手机横屏，并且完成签名：</div>

		</div>
	</div>
</template>

<script>

import { rotateBase64Img } from "../utils/index";
	export default {
		name: 'SignCanvas',
		components: {},

		props: {
			// 画布宽度，即导出图片的宽度
			width: {
				type: Number,
				default: () => {
					const dom = document.querySelector('#app')
					const width = dom && dom.offsetWidth
					return width ? width - 115 : 300 // 减去按钮区域的宽度
				}
			},
			// 画布高度，即导出图片的高度
			height: {
				type: Number,
				default: () => {
					const dom = document.querySelector('#app')
					// return (dom && dom.offsetHeight) || 800
					return (dom && dom.offsetHeight) ? dom && dom.offsetHeight - 30 : 800
				}
			},
			// 画笔粗细
			lineWidth: {
				type: Number,
				default: 6
			},
			// 画笔颜色
			lineColor: {
				type: String,
				default: '#000'
			},
			// 画布背景色，为空时画布背景透明，支持多种格式 '#ccc'，'#E5A1A1'，'rgb(229, 161, 161)'，'rgba(0,0,0,.6)'，'red'
			bgColor: {
				type: String,
				default: '#F3F3F3'
			},
			// 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
			isCrop: {
				type: Boolean,
				default: false
			},
			// 清空画布时(reset)是否同时清空设置的背景色(bgColor)
			isClearBgColor: {
				type: Boolean,
				default: true
			},
			// 生成图片格式 image/jpeg(jpg格式下生成的图片透明背景会变黑色请慎用或指定背景色)、 image/webp
			format: {
				type: String,
				default: 'image/png'
			},
			// 生成图片质量；在指定图片格式为 image/jpeg 或 image/webp的情况下，可以从 0 到 1 的区间内选择图片的质量。如果超出取值范围，将会使用默认值 0.92。其他参数会被忽略。
			quality: {
				type: Number,
				default: 1
			},
			// 未签名时提示信息
			noSignTipText: {
				type: String,
				default: '请确保已签名！'
			},
			// 需要签名的姓名
			signName: {
				type: String,
				default: ''
			}
		},

		methods: {
			resetHandler() {
				this.$refs.VueEsignRef.reset() // 清空画布
			},
			clearHandler() {
				this.$emit('clearHandler')
				this.resetHandler()
			},
			sureHandler() {
				// 可选配置参数 ，在未设置format或quality属性时可在生成图片时配置 例如： {format:'image/jpeg', quality: 0.5}
				// this.$refs.esign.generate({format:'image/jpeg', quality: 0.5})
				this.$refs.VueEsignRef.generate()
					.then(res => {
						/**
						 * res：base64图片
						 */
						rotateBase64Img(res, 270, `${this.signName ? this.signName + '-签名.jpg' : 'sign.jpg'}`, '',
							data => {
								this.$emit('sureHandler', data)
							})
					})
					.catch(err => {
						console.log('err----', err)
						
					})
			}
		}
	}
</script>

<style lang='scss' scoped>
	.signContainer {
		width: 100%;
		box-sizing: border-box;
		margin-top: 15px;
		height: calc(100vh - 30px);
		display: flex;
		background-color: #fff;




	}

	.icon1 {
			transform: rotate(90deg) translateX(0px);
		width: 13px;
		height: 15px;
		
	}

	.tipDetail2 {
		width: 240px;
			transform: rotate(90deg) translateX(120px);
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}

	.tips {
		height: 100%;
		width: 65px;
		background-color: #f8f8f8;
		display: flex;
		flex-direction: column;

	}

	.tipDetail {

		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		transform: rotate(90deg) translateX(30px);
		text-align: center;
		white-space: nowrap;

	}

	.vue-esign {
		z-index: 2;
		background: #F3F3F3;
		border-radius: 4px;
	}

	.tipText {
		position: absolute;
		top: 50%;
		width: var(--width);
		left: calc(50% + 55px);
		transform: translateX(-50%) translateY(-50%) rotateZ(90deg);
		text-align: center;
		color: #ddd;
		letter-spacing: 2px;

	}

	.btns {
	
		height: calc(100vh - 30px);
		width: 65px;
		background-color: #f8f8f8;
		display: flex;
		flex-direction: column;

	   align-items: center;
	

	}

	.mybutton1 {
		width: 87px;
		height: 35px;
		background: #F9F9F9;
		border-radius: 8px;
		border: 1px solid rgba(5,5,5,0.08);
		transform: rotate(90deg) translateX(500px);
		text-align: center;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #333333;
line-height: 35px;
text-align: center;
	}
.mybutton2 {
		width: 87px;
		height: 35px;
		background: #409EFF;
		border-radius: 8px;
	
		transform: rotate(90deg) translateX(600px);
		text-align: center;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #fff;
line-height: 35px;
text-align: center;
	}
	.van-button__text {
		letter-spacing: 5px;
	}
</style>


// WEBPACK FOOTER //
// SignCanvas.vue?909656c6